import { GROUP_ROLES as g_roles } from 'constants';

export const PATICIPANTS = length => (length > 1 ? 'PATICIPANTS' : 'PATICIPANT');
export const CANCEL_ACTION_SHEET = 'Cancel';
export const CREATE_PM_CONV = 'Send Direct Message';
export const MAKE_ADMIN = 'Make Admin';
export const UNMAKE_ADMIN = 'Unmake Admin';
export const REMOVE_MEMBER = 'Remove from group';
export const VIEW = 'View';
export const DOWNLOAD = 'Download';
export const DELETE = 'Delete';
export const EDIT = 'Edit';
export const SUBMIT = 'Upload Submittion';
export const NO_TASK_ADMIN = 'Click Add Task Button To Add A New Task';
export const NO_TASK_MEMBER = 'No Added Tasks Yet';
export const NO_MATERIAL_ADMIN = 'Click Upload Button To Upload A New Material';
export const NO_MATERIAL_MEMBER = 'No Added Materials Yet';
export const MUTE = 'Mute';
export const GALLERY = 'Photos, Videos and Links';
export const LEAVE_GROUP = 'Leave Group';
export const BLOCKED_MEMBERS = 'Blocked Members';
export const ADD_PARTICIPANT = 'Add Participant';
export const JOIN_CLOSED = 'Joining is closed';
export const JOIN_OPENED = 'Joining is Open';
export const EDIT_GROUP_INFO = 'Edit Group Info';
export const INV_CODE = 'Invitation Code:';
export const JOIN_CLOSE_MSG = `Joining to the group has been closed by the admin`;
export const SUBMIT_MSG = title => `Submitted ${title}`;
export const SUBMISSION_COUNTER = (counter, total) => `${counter} out of ${total} had submitted`;
export const GROUPS_IN_COMMON = 'Groups In Common';
export const BLOCK_MEMBER = 'Block And Report';

export const GROUP_ROLES = {
    [g_roles.ADMIN]: 'Admin',
    [g_roles.MEMBER]: 'Member',
    [g_roles.CREATOR]: 'Creator'
};

export const TASK_TYPES = {
    GENERAL: 'General',
    HOMEWORK: 'Homework',
    MAJOR_EXAM: 'Major Exam',
    MID_TERM: 'Mid Term',
    FINAL_EXAM: 'Final Exam',
    QUIZ: 'Quiz',
    PROJECT: 'Project',
    PRESENTATION: 'Presentation'
};



// WEBPACK FOOTER //
// ./src/lang/en/right.js